import React, { useCallback, useEffect, useState } from "react"
import ButtonCollapse from "./ButtonCollapse"
import ButtonRefresh from "./ButtonRefresh"
import InputSearch from "./InputSearch"
import LoadingCard from "./LoadingCard"
import Sweetalert from "../utils/Sweetalert"
import API from "../utils/API"
import AdCanvaCardItem from "./AdCanvaCardItem"
import ButtonLink from "./ButtonLink"

export default function AdCanvaCard({ setCurrentAdPath, totems }) {
  // State
  const [canvaItems, setCanvaItems] = useState(null)
  const [canvaPath, setCanvaPath] = useState([{ id: "root", name: "Canva" }])
  const [continuation, setContinuation] = useState(null)
  const [search, setSearch] = useState("")
  const [loading, setLoading] = useState(true)

  // Comportements
  const getCanvaItems = () => {
    setLoading(true)

    API.GET(
      `/canva/items?folderId=${canvaPath[canvaPath.length - 1].id}${
        continuation ? `&continuation=${continuation}` : ""
      }`,
      (response) => {
        if (continuation) setCanvaItems([...canvaItems, ...response.data.items])
        else setCanvaItems(response.data.items)

        if (response.data.continuation) setContinuation(response.data.continuation)
        else setContinuation(null)

        setLoading(false)
      },
      (errorMessage) => {
        setLoading(false)
        Sweetalert.fireErrorToast(errorMessage)
      }
    )
  }

  useEffect(() => {
    getCanvaItems()
  }, [canvaPath])

  const buildBreadcrumb = useCallback(() => {
    return canvaPath.map((item, index) =>
      index < canvaPath.length - 1 ? (
        <span key={item.id} onClick={() => handleClick(item)} style={{ color: "#007bff", cursor: "pointer" }}>
          {item.name}
          {" / "}
        </span>
      ) : (
        <span key={item.id}>{item.name}</span>
      )
    )
  }, [canvaPath])

  const handleClick = (item) => {
    if (item.type) {
      if (item.type === "folder") {
        setCanvaPath([...canvaPath, { id: item.folder.id, name: item.folder.name }])
        setCanvaItems(null)
      } else {
        if (item[item.type].urls && item[item.type].urls.view_url) {
          window.open(item[item.type].urls.view_url, "_blank")
        }
      }
    } else {
      // Bouton retour ou autre lien direct de remontée
      const itemIndex = canvaPath.findIndex((path) => path.id === item.id)
      if (itemIndex !== -1) {
        setCanvaPath(canvaPath.slice(0, itemIndex + 1))
        setCanvaItems(null)
      }
    }
  }

  const handleCreateFolder = () => {
    Sweetalert.askName(
      "Nom du dossier",
      "Définissez le nom du dossier à créer",
      "Nom (Exemple : Dossier 1)",
      (response) => {
        API.POST(
          "/canva/folder",
          {
            name: response.value,
            parentFolderId: canvaPath[canvaPath.length - 1].id,
          },
          (response) => {
            let canvaItemsCopy = [...canvaItems]

            canvaItemsCopy.push({ type: "folder", ...response.data })

            setCanvaItems(canvaItemsCopy)
          },
          (errorMessage) => {
            Sweetalert.fireErrorToast(errorMessage)
          }
        )
      }
    )
  }

  const handleCreateDesign = () => {
    Sweetalert.askDesignNameAndPlayer(totems, (name, totemSize) => {
      const size = totemSize.split("x")

      API.POST(
        `/canva/design`,
        {
          name,
          width: parseInt(size[0]),
          height: parseInt(size[1]),
          parentFolderId: canvaPath[canvaPath.length - 1].id,
        },
        (response) => {
          let canvaItemsCopy = [...canvaItems]

          canvaItemsCopy.push({ type: "design", ...response.data })

          setCanvaItems(canvaItemsCopy)
        },
        (errorMessage) => {
          Sweetalert.fireErrorToast(errorMessage)
        }
      )
    })
  }

  // Rendu
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Ressources - {buildBreadcrumb()}</h3>
        <div className="card-tools">
          <button className="btn btn-info btn-xs mr-2" onClick={handleCreateFolder}>
            <i className="fas fa-plus"></i>
            <span className="ml-1">Nouveau dossier</span>
          </button>
          <InputSearch value={search} onChange={(event) => setSearch(event.target.value.toLowerCase())} />
          <ButtonRefresh onClick={getCanvaItems} />
          <ButtonCollapse />
        </div>
      </div>
      <div className="card-body p-0" style={{ display: "block" }}>
        <LoadingCard loaded={!loading}>
          <ul className="users-list clearfix">
            <li className="pt-4 pb-4" style={{ height: "300px" }}>
              <ButtonLink
                style={{ width: "100%" }}
                type="button"
                onClick={() => {
                  if (canvaPath.length > 1) handleClick(canvaPath[canvaPath.length - 2])
                  else setCurrentAdPath(null)
                }}
              >
                <i className="fas fa-folder" style={{ fontSize: "3rem", color: "#007bff" }}></i>
                <span className="users-list-name">Retour</span>
              </ButtonLink>
            </li>

            {canvaItems &&
              canvaItems.map((item) => (
                <AdCanvaCardItem item={item} onClick={() => handleClick(item)} refresh={getCanvaItems} />
              ))}

            <li className="pt-4 pb-4" style={{ height: "300px" }}>
              <ButtonLink style={{ width: "100%" }} type="button" onClick={handleCreateDesign}>
                <i className="fas fa-plus" style={{ fontSize: "3rem", color: "#17a2b8" }}></i>
                <span className="users-list-name">Créer un nouveau design</span>
              </ButtonLink>
            </li>
          </ul>
        </LoadingCard>
      </div>
    </div>
  )
}
